"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.global = void 0;
exports.global = require("./global");
//# sourceMappingURL=index.js.map